export function getPersons(){
	return persons;
}

const persons = [
	{"id":1,"value":"Tommie Shurtleff"},
	{"id":2,"value":"Dottie Ward"},
	{"id":3,"value":"Camilla Mcculley"},
	{"id":4,"value":"Jesse Holdman"},
	{"id":5,"value":"Isaiah Greggs"},
	{"id":6,"value":"Lacy Fordham"},
	{"id":7,"value":"Cyril Barone"},
	{"id":8,"value":"Gita Noda"},
	{"id":9,"value":"Rolando Schulze"},
	{"id":10,"value":"Abdul Abshire"},
	{"id":11,"value":"Cristin Hakala"},
	{"id":12,"value":"Marcus Memmott"},
	{"id":13,"value":"Micha Seawell"},
	{"id":14,"value":"Keely Auston"},
	{"id":15,"value":"Vincent Maday"},
	{"id":16,"value":"Tomika Gully"},
	{"id":17,"value":"Delcie Kauffman"},
	{"id":18,"value":"Lorena Rush"},
	{"id":19,"value":"Ruthanne Rast"},
	{"id":20,"value":"Tesha Gram"},
	{"id":21,"value":"Bell Bunce"},
	{"id":22,"value":"Xavier Thornell"},
	{"id":23,"value":"Libbie Pennell"},
	{"id":24,"value":"Cassaundra Juneau"},
	{"id":25,"value":"Annika Andino"},
	{"id":26,"value":"Pat Merkel"},
	{"id":27,"value":"Ethelyn Riendeau"},
	{"id":28,"value":"Normand Malia"},
	{"id":29,"value":"Rachell Hause"},
	{"id":30,"value":"Shaun Lasiter"},
	{"id":31,"value":"Paola Poteat"},
	{"id":32,"value":"Shelly Beagle"},
	{"id":33,"value":"Heike Cunningham"},
	{"id":34,"value":"Estrella Bring"},
	{"id":35,"value":"Elenore Sandman"},
	{"id":36,"value":"Bertha Hotaling"},
	{"id":37,"value":"Omega Rasnake"},
	{"id":38,"value":"Ali Crawley"},
	{"id":39,"value":"Brianna Augsburger"},
	{"id":40,"value":"Tyree Harrold"},
	{"id":41,"value":"Samantha Stucker"},
	{"id":42,"value":"Jeannette Mcdonnell"},
	{"id":43,"value":"Lawanna Dunmore"},
	{"id":44,"value":"Micaela Pedretti"},
	{"id":45,"value":"Alison Vogt"},
	{"id":46,"value":"Marcia Dicarlo"},
	{"id":47,"value":"Jeanelle Waggoner"},
	{"id":48,"value":"Emelda Araiza"},
	{"id":49,"value":"Lasonya Capozzi"},
	{"id":50,"value":"Toshia Lininger"}
];